import { useTranslations } from "next-intl";
import { ButtonLink } from "@/components/ui/button";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

const CultureMoreInfo = () => {
  const t = useTranslations();

  return (
    <Container className={S.moreInfoWrap}>
      <div className={S.title}>
        {t("culture.moreInfo.0")}
        <h2 className={S["title--blue"]}>{t("culture.moreInfo.1")}</h2>
      </div>
      <ButtonLink arrow variant="trBlackToBlack" href="https://vk.com/aquaart_group" target="_blank" rel="noreferrer">
        {t("resources.vk")}
      </ButtonLink>
    </Container>
  );
};

export default CultureMoreInfo;
